import { Button } from "components/Button";
import {
  Phone as IconPhone,
  WhatsApp as IconWhatsApp,
  MailOutline as IconMail,
} from "@material-ui/icons";
import { Menu, MenuItem } from "@material-ui/core";
import React from "react";

export function ButtonContact() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        startIcon={<IconPhone />}
        variant="outlined"
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        FALE CONOSCO
      </Button>

      <Menu
        style={{ marginTop: "1.8rem" }}
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <a target="_blank" href="https://wa.me/+5527988834204" rel="noreferrer">
          <MenuItem onClick={handleClose}>
            <IconWhatsApp color={"primary"} style={{ marginRight: "0.4rem" }} />{" "}
            WhatsApp
          </MenuItem>
        </a>

        <a
          target="_blank"
          href="mailto:contato@comparetaxa.com.br"
          rel="noreferrer"
        >
          <MenuItem onClick={handleClose}>
            <IconMail color="primary" style={{ marginRight: "0.4rem" }} />{" "}
            Enviar um e-mail
          </MenuItem>
        </a>
      </Menu>
    </div>
  );
}
